export const EXPANDED_WIDTH = 265;
export const COLLAPSED_WIDTH = 70;
